"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructMoatData = void 0;
exports.constructMoatData = function (_a) {
    var _b;
    var tdata = _a.tdata;
    var moatTrackerData = (((_b = tdata === null || tdata === void 0 ? void 0 : tdata.web) === null || _b === void 0 ? void 0 : _b.filter(function (tracker) { return tracker.vendor === 'Moat'; })) || [])[0];
    if (moatTrackerData === null || moatTrackerData === void 0 ? void 0 : moatTrackerData.verificationParameters) {
        var _c = moatTrackerData.verificationParameters, _d = _c.moatClientLevel1, moatClientLevel1 = _d === void 0 ? '_ADVERTISER_' : _d, _e = _c.moatClientLevel2, moatClientLevel2 = _e === void 0 ? '_CAMPAIGN_' : _e, _f = _c.moatClientLevel3, moatClientLevel3 = _f === void 0 ? '_LINE_ITEM_' : _f, _g = _c.moatClientLevel4, moatClientLevel4 = _g === void 0 ? '_CREATIVE_' : _g, _h = _c.moatClientSlicer1, moatClientSlicer1 = _h === void 0 ? '_SITE_' : _h, _j = _c.moatClientSlicer2, moatClientSlicer2 = _j === void 0 ? '_PLACEMENT_' : _j, _k = _c.zMoatPosition, zMoatPosition = _k === void 0 ? '_POSITION_' : _k;
        return {
            moatClientLevel1: moatClientLevel1,
            moatClientLevel2: moatClientLevel2,
            moatClientLevel3: moatClientLevel3,
            moatClientLevel4: moatClientLevel4,
            moatClientSlicer1: moatClientSlicer1,
            moatClientSlicer2: moatClientSlicer2,
            zMoatPosition: zMoatPosition,
        };
    }
};
//# sourceMappingURL=construct-moat-data.js.map